import { RefObject, useEffect, useRef, useState } from "react";

// Observes an element's own width via ResizeObserver so components can respond
// to the space they actually have rather than the viewport width. Mirrors the
// ResizeObserver pattern used by usePdfContainerWidth.
const useElementWidth = (): {
  ref: RefObject<HTMLDivElement | null>;
  width: number;
} => {
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const updateWidth = () => {
      const w = element.clientWidth;
      if (w > 0) setWidth(w);
    };

    const observer = new ResizeObserver(updateWidth);
    observer.observe(element);
    updateWidth();

    return () => observer.disconnect();
  }, []);

  return { ref, width };
};

export default useElementWidth;
